import {
  ROOMW,
  ROOMH,
  ROOMD,
  PJX,
  PJY,
  PJZ,
  SCRNW,
  SCRNH,
  BOARDW,
  BOARDH,
  F_S2D,
  F_D2S,
  VLENSSHIFT,
  HLENSSHIFT,
  VHLENSSHIFT,
  DIST,
  PJHEIGHT,
  F_VOFFSET,
  PROPORTION,
  ASPECTRATIO,

  USERINPUTMODELNAME,
  SPECIFICATIONMATCHINGMODELDATA,
  INSTALLMATCHINGMODELDATA,
  SEARCHMATCHINGMODELDATA,
  SEARCHSELECTEDMODELDATA,
  SEARCHMATCHINGLENSID,
  SEARCHSELECTEDLENSDATA,

  BMMATCHINGMODELDATA,
  BMSELECTEDMODELDATA,
  BMMATCHINGLENSID,
  BMSELECTEDLENSDATA,
  SELECTRATIODATA,

  HTMMATCHINGMODELDATA,
  HTMSELECTEDMODELDATA,
  HTMMATCHINGLENSID,
  HTMSELECTEDLENSDATA,

  MATCHINGMODELDATA,
  SELECTEDMODELDATA,
  MATCHINGLENSID,
  SELECTEDLENSDATA,

  CATERADIO,
  CATEVALUE,
  SCREENSIZE,
  SET_UNIT,
  SET_OTHER_POSITION,
  SET_GRAPH_ROOMW,
  SET_GRAPH_ROOMH,
  SET_GRAPH_ROOMD,
  SET_GRAPH_PJY,
  SET_GRAPH_SCRNW,
  SET_GRAPH_SCRNH,
  SET_SCREENSIZE,
  SET_BRIGHTNESS,
  SET_VANGLE,
  SET_VANGLEFLAG,
  SET_HANGLE,
  SET_HANGLEFLAG,
  SET_OFFSET,
  SET_FLOOR2BOTTOM,
  SET_SELECTEDLENSDATA_ASPECTRATIO,
  SET_VLENSSHIFT,
  SET_HLENSSHIFT,
  SET_INITSCREENSIZEW,
  SET_INITSCREENSIZEH,
  SET_OLDTX,
  SET_OLDTY,
  SET_PJIMGTYPE,
  SET_GAIN,
  SET_APPLICATION,
  SET_PROJECTORCHECKED,
  SET_THROWDISTANCECHECKED,
  SET_SCREENSIZECHECKED,
  SET_PJZTIP,
  SET_PJXTIP,
  SET_DRAWDATA,
  SET_SCREENEDGESDRAWDATA,
  SET_BLACKDRAWDATA,
  SET_RANGEDRAWDATA,
  SET_BLACKSIZE,
  SET_CENTERPOSITIONINIT,
  SET_CENTERPOINTDATA,
  CHANGE_VIEW,
  SET_PROJECTORCHECKEDSIDE,
  SET_PROJECTORCHECKEDTOP,
  SET_FLTOB,
  SET_FLTOL,
  SET_DASHFLAG,
  SET_DASHDATA,
  SET_DASHDATAREMAIN,
  SET_ISTOUCH,
  SET_THEME,
  SET_SCREEN4POINT,
  SET_POSITION,
  SET_SCREENMOVECHECKED,
  SET_THREEDPJCHECKED,
  SET_FOCUSVIEW,
  SET_BROWSERTYPE,
  SET_TEMVLENSSHIFT,
  SET_ISUSTWALL,
  SET_USTPJTOP,
  SET_SIMPLEPJTOP,
  SET_USTVDRAGFLAG,
  SET_USTLENSHIFTV,
  SET_BOARDSTATUSTOP,
  SET_TOUCHINSTALL,
  SET_FINGERTOUCHSTATUS,
  SET_FTULOCATIONSTATE,
  SET_WHITEBOARDSTATUS,
  SET_SHOWINPUTFLAG,
  SET_TEXTDATA,
  SET_KEYSTONEVERTICAL,
  SET_KEYSTONEHORIZONTAL,
  SET_OUTOFSPECVAL,
  SET_ISOUTOFSPEC,
  SET_ISVANGLEOUT,
  SET_LANGUAGEDEFAULT,
  SET_SEARCHTABACTIVE,
  SET_ISSIMPLE,
  SET_REALTHROWDISTANCECHECKED,
  SET_USTTHROWDISSLIDERTMAX,
  SET_USTSCREENSIZEMAX,
  SET_USTLENSTOFRONTPJ,
  SET_MUPOINTS,
  SET_DISABLEDNONE,
  SET_CURVESHAPE,
  SET_CURVEDIRECTION,
  SET_SETTINGACTIVE,
  SET_CURVEDEPTH,
  SET_LENSSHIFTRANGEBOOL,
  SET_LENSSHIFTRANGE,
  SET_BRIGHTNESSGUIDE,
  SET_CURVECENTER,
  SET_FONTSIZE,
  SET_CURVERADIUS,
  SET_TABACTIVENAME,
  SET_INDANGLESWITCH,
  SET_INDANGLEREMAINPINTS,
  SET_CORNERCORAREAS,
  SET_ISONCORNERAREAS,
  SET_TOUCHWALLFLAG,
  SET_CURVECENTRALANGLE,
  SET_CURVECHORDLENGTH,
  SET_CURVESCREENHEIGHT,
  SET_BLENDING_SCREEN_SHAPE,
  SET_BLENDING_SCREEN_SHAPESHOW,
  SET_BLENDING_SCREEN_WIDHT,
  SET_BLENDING_SCREEN_HEIGHT,
  SET_BLENDING_RATIO,
  SET_BLENDING_RADIUS,
  SET_BLENDING_SCREENHEIGHT,
  SET_BLENDING_LENSHEIGHT,
  SET_BLENDING_LENSHEIGHTRATE_MIN,
  SET_BLENDING_LENSHEIGHTRATE_MAX,
  SET_BLENDING_CURVESELECT,
  SET_BLENDING_ANGLE,
  SET_BLENDING_DEPTH,
  SET_BLENDING_ARC,
  SET_BLENDING_AVAPOINT,
  SET_BLENDING_ISPROJECTPOSITION,
  SET_BLENDING_SIMULATETABDATA,
  SET_BLENDING_SIMULATETABSELE,
  SET_BLENDINGUNIT,
  SET_BLENDING_POSITION,
  SET_BLENDING_SELENSDATA,
  SET_BLENDING_VLENSSHIFT,
  SET_BLENDING_HLENSSHIFT,
  SET_BLENDING_VHLENSSHIFT,
  SET_BLENDING_VLENSSHIFTNOW,
  SET_BLENDING_RANGE_MIN,
  SET_SCREENSIZEACTIVE,
  SET_BLENDING_RANGE_MAX,
  SET_BLENDING_NUMBER_H,
  SET_BLENDING_NUMBER_V,
  SET_BLENDING_LENSSHIFTV,
  SET_BLENDING_POSITIONLIMITW,
  SET_BLENDING_POSITIONLIMITH,
  SET_SIMULATESWITCHFLAG,
  SET_BLENDINGEDGEPOINTS,
  SET_THROWACTIVE,
  SET_THROWDISSLIDERTFORMAT,
  SET_THROWDISSLIDERWFORMAT,
  SET_RATIOSCREENSIZEMIN,
  SET_RATIOSCREENSIZEMAX,
  SET_THROWERROR,
  SET_MDDEDATA,
  SET_FROMBLENDING,
  SET_BLENDING,
  SET_THROWDISTANCE2SCREENSIZWIDTH,
  SET_LANGUAGEFLAG,
  SET_MIXRATEHVAL,
  SET_MIXRATEVVAL,
  SET_FLOORFOOTPROJECTORCHECKED,
  SET_CONTRASTDATA,
  SET_DISTANCE2WALL,
  SET_CURVEDCORRECTIONSCREEN_W,
  SET_CURVEDCORRECTIONSCREEN_H,
  SET_CURVEDCORRECTIONSCREEN_SIZE,
  SET_ALL,
  SET_SAVE_DATE,
  SET_RESET_STATE,
  SET_HISTORY_RADIO,
  SET_HISTORY_KEY,
  SET_THROWDISSLIDERMIN,
  SET_THROWDISSLIDERMAX,
  SET_THROWDISSLIDERW,
  SET_THROWDISSLIDERT,
  SET_OVERLAPH,
  SET_OVERLAPV,
  SET_ISHISTORYROWCLICK,
  SET_CORRECTIONNGINFOMSG,
  SET_LIMITVALUE,
  SET_LENSLIST,
  SET_WIDESTATUS,
  SET_TELESTATUS,
  SET_RECOMMENDLENS,
  SET_BLENDINGEDGEPOINTS_INIT,
  SET_CAMERA_ASSIST_SIZE_MIN,
  SET_CAMERA_ASSIST_SIZE_MAX,
  SET_DATA_TIPS,
  SET_PROJECTION_COVER_SCREEN,
  SET_CEILINGBOTTOMPROJECTORCHECKED,
  SET_WALLWALLPROJECTORCHECKED
} from './mutations_types.js'

import { getMatchingLensById } from '../common/common.js'

export default {
  [ROOMW] (state, val) {
    state.houseInfo.roomW = val
  },
  [ROOMH] (state, val) {
    state.houseInfo.roomH = val
  },
  [ROOMD] (state, val) {
    state.houseInfo.roomD = val
  },
  [PJX] (state, val) {
    state.graph.pjX = val
  },
  [PJY] (state, val) {
    state.graph.pjY = val
  },
  [PJZ] (state, val) {
    state.graph.pjZ = val
  },
  [SCRNW] (state, val) {
    state.graph.scrnW = val
  },
  [SCRNH] (state, val) {
    state.graph.scrnH = val
  },
  [BOARDW] (state, val) {
    state.graph.boardW = val
  },
  [BOARDH] (state, val) {
    state.graph.boardH = val
  },
  [F_S2D] (state, val) {
    state.graph.f_s2d = val
  },
  [F_D2S] (state, val) {
    state.graph.f_d2s = val
  },
  [VLENSSHIFT] (state, val) {
    state.graph.vLensShift = val
  },
  [HLENSSHIFT] (state, val) {
    state.graph.hLensShift = val
  },
  [VHLENSSHIFT] (state, val) {
    state.graph.vhLensShift = val
  },
  [DIST] (state, val) {
    state.dist = val
  },
  [PJHEIGHT] (state, val) {
    state.pjHeight = val
  },
  [F_VOFFSET] (state, val) {
    state.f_vOffset = val
  },
  [PROPORTION] (state, val) {
    state.proportion = val
  },
  [ASPECTRATIO] (state, val) {
    state.aspectRatio = val
  },

  [USERINPUTMODELNAME] (state, val) {
    state.userInputModelName = val
  },
  [INSTALLMATCHINGMODELDATA] (state, val) {
    state.installMatchingModelData = val
  },
  [SPECIFICATIONMATCHINGMODELDATA] (state, val) {
    state.specificationMatchingModelData = val
  },
  [SEARCHMATCHINGMODELDATA] (state, val) {
    state.searchMatchingModelData = val
  },
  [SEARCHSELECTEDMODELDATA] (state, val) {
    state.searchSelectedModelData = val
  },
  [SEARCHMATCHINGLENSID] (state, val) {
    state.searchMatchingLensID = val
  },
  [SEARCHSELECTEDLENSDATA] (state, val) {
    state.searchSelectedLensData = val
  },

  [BMMATCHINGMODELDATA] (state, val) {
    state.bmMatchingModelData = val
  },
  [BMSELECTEDMODELDATA] (state, val) {
    state.bmSelectedModelData = val
  },
  [BMMATCHINGLENSID] (state, val) {
    if (!val || val.length === 0) {
      state.bmMatchingLensID = val
    } else if (val[0].name) {
      state.bmMatchingLensID = val
    } else {
      state.bmMatchingLensID = getMatchingLensById(val, state.selectedModelData.lcdSize)
    }
  },
  [BMSELECTEDLENSDATA] (state, val) {
    state.bmSelectedLensData = val
  },
  [SELECTRATIODATA] (state, val) {
    state.selectRatioData = val
  },

  [HTMMATCHINGMODELDATA] (state, val) {
    state.htmMatchingModelData = val
  },
  [HTMSELECTEDMODELDATA] (state, val) {
    state.htmSelectedModelData = val
  },
  [HTMMATCHINGLENSID] (state, val) {
    state.htmMatchingLensID = val
  },
  [HTMSELECTEDLENSDATA] (state, val) {
    state.htmSelectedLensData = val
  },

  [MATCHINGMODELDATA] (state, val) {
    state.matchingModelData = val
  },
  [SELECTEDMODELDATA] (state, val) {
    state.selectedModelData = val
    state.position = val.position
  },
  [MATCHINGLENSID] (state, val) {
    if (!val || val.length === 0) {
      state.matchingLensID = val
    } else if (val[0].name) {
      state.matchingLensID = val
    } else {
      state.matchingLensID = getMatchingLensById(val, state.selectedModelData.lcdSize)
    }
  },
  [SELECTEDLENSDATA] (state, val) {
    state.selectedLensData = val
  },
  [CATERADIO] (state, val) {
    state.cateRadio = val
  },
  [CATEVALUE] (state, val) {
    state.cateValue = val
  },
  [SCREENSIZE] (state, val) {
    state.screenSize = val
  },
  [SET_UNIT] (state, val) {
    state.graph.unit = val
  },
  [SET_OTHER_POSITION] (state, val) {
    state.selectedModelData.position = val
  },
  [SET_GRAPH_ROOMW] (state, val) {
    state.houseInfo.roomW = val
  },
  [SET_GRAPH_ROOMH] (state, val) {
    state.houseInfo.roomH = val
  },
  [SET_GRAPH_ROOMD] (state, val) {
    state.houseInfo.roomD = val
  },
  [SET_GRAPH_PJY] (state, val) {
    state.graph.pjY = val
  },
  [SET_GRAPH_SCRNW] (state, val) {
    state.graph.scrnW = val
  },
  [SET_GRAPH_SCRNH] (state, val) {
    state.graph.scrnH = val
  },
  [SET_SCREENSIZE] (state, val) {
    state.screenSize = val
  },
  [SET_BRIGHTNESS] (state, val) {
    state.brightness = val
  },
  [SET_VANGLE] (state, val) {
    state.vAngle = val
  },
  [SET_VANGLEFLAG] (state, val) {
    state.vAngleFlag = val
  },
  [SET_HANGLE] (state, val) {
    state.hAngle = val
  },
  [SET_HANGLEFLAG] (state, val) {
    state.hAngleFlag = val
  },
  [SET_OFFSET] (state, val) {
    state.offset = val
  },
  [SET_FLOOR2BOTTOM] (state, val) {
    state.floor2bottom = val
  },
  [SET_SELECTEDLENSDATA_ASPECTRATIO] (state, val) {
    state.selectedLensData.lcd.aspectRatio = val
  },
  [SET_VLENSSHIFT] (state, val) {
    state.vLensShiftNow = val
  },
  [SET_HLENSSHIFT] (state, val) {
    state.hLensShiftNow = val
  },
  [SET_INITSCREENSIZEW] (state, val) {
    state.initScreenSize.w = val
  },
  [SET_INITSCREENSIZEH] (state, val) {
    state.initScreenSize.h = val
  },
  [SET_OLDTX] (state, val) {
    state.oldT.x = val
  },
  [SET_OLDTY] (state, val) {
    state.oldT.y = val
  },
  [SET_PJIMGTYPE] (state, val) {
    state.pjImgType = val
  },
  [SET_GAIN] (state, val) {
    state.gain = val
  },
  [SET_APPLICATION] (state, val) {
    state.application = val
  },
  [SET_PROJECTORCHECKED] (state, val) {
    state.projectorChecked = val
  },
  [SET_THROWDISTANCECHECKED] (state, val) {
    state.throwDistanceChecked = val
  },
  [SET_SCREENSIZECHECKED] (state, val) {
    state.screenSizeChecked = val
  },
  [SET_REALTHROWDISTANCECHECKED] (state, val) {
    state.realThrowDistanceChecked = val
  },
  [SET_USTTHROWDISSLIDERTMAX] (state, val) {
    state.ustThrowDisSlidertMax = val
  },
  [SET_USTSCREENSIZEMAX] (state, val) {
    state.ustScreenSizeMax = val
  },
  [SET_PJZTIP] (state, val) {
    state.pjZTip = val
  },
  [SET_PJXTIP] (state, val) {
    state.pjXTip = val
  },
  [SET_DRAWDATA] (state, val) {
    state.drawData = val
  },
  [SET_SCREENEDGESDRAWDATA] (state, val) {
    state.screenEdgesDrawData = val
  },
  [SET_BLACKDRAWDATA] (state, val) {
    state.blackDrawData = val
  },
  [SET_CENTERPOSITIONINIT] (state, val) {
    state.centerPositionInit = val
  },
  [SET_RANGEDRAWDATA] (state, val) {
    state.rangeDrawData = val
  },
  [SET_CENTERPOINTDATA] (state, val) {
    state.centerPointData = val
  },
  [CHANGE_VIEW] (state, data) {
    state.view = data
  },
  [SET_BLACKSIZE] (state, val) {
    state.blackSize = val
  },
  [SET_PROJECTORCHECKEDSIDE] (state, val) {
    state.projectorCheckedSide = val
  },
  [SET_PROJECTORCHECKEDTOP] (state, val) {
    state.projectorCheckedTop = val
  },
  [SET_FLTOB] (state, val) {
    state.flToB = val
  },
  [SET_FLTOL] (state, val) {
    state.flToL = val
  },
  [SET_DASHFLAG] (state, val) {
    state.dashFlag = val
  },
  [SET_DASHDATA] (state, val) {
    state.dashData = val
  },
  [SET_DASHDATAREMAIN] (state, val) {
    state.dashDataRemain = val
  },
  [SET_ISTOUCH] (state, val) {
    state.isTouch = val
  },
  [SET_THEME] (state, val) {
    state.theme = val
  },
  [SET_SCREEN4POINT] (state, val) {
    state.screen4Point = val
  },
  [SET_POSITION] (state, val) {
    state.position = val
  },
  [SET_SCREENMOVECHECKED] (state, val) {
    state.screenMoveChecked = val
  },
  [SET_THREEDPJCHECKED] (state, val) {
    state.threeDPJChecked = val
  },
  [SET_FOCUSVIEW] (state, val) {
    state.focusView = val
  },
  [SET_BROWSERTYPE] (state, val) {
    state.browserType = val
  },
  [SET_TEMVLENSSHIFT] (state, val) {
    state.temVLensShift = val
  },
  [SET_ISUSTWALL] (state, val) {
    state.isUSTWall = val
    if (val && state.outOfSpecVal) {
      state.isOutOfSpec = false
    } else if (!val && state.outOfSpecVal) {
      state.isOutOfSpec = true
    }
  },
  [SET_USTPJTOP] (state, val) {
    state.USTPjTop = val
  },
  [SET_SIMPLEPJTOP] (state, val) {
    state.SimplePjTop = val
  },
  [SET_USTVDRAGFLAG] (state, val) {
    state.USTVDragFlag = val
  },
  [SET_USTLENSHIFTV] (state, val) {
    state.USTLenshiftV = val
  },
  [SET_BOARDSTATUSTOP] (state, val) {
    state.boardStatusTop = val
  },
  [SET_TOUCHINSTALL] (state, val) {
    state.touchInstall = val
  },
  [SET_FINGERTOUCHSTATUS] (state, val) {
    state.fingerTouchStatus = val
  },
  [SET_FTULOCATIONSTATE] (state, val) {
    state.FTULocationState = val
  },
  [SET_WHITEBOARDSTATUS] (state, val) {
    state.whiteboardStatus = val
  },
  [SET_SHOWINPUTFLAG] (state, val) {
    state.showInputFlag = val
  },
  [SET_TEXTDATA] (state, val) {
    state.textDataView = val
  },
  [SET_KEYSTONEVERTICAL] (state, val) {
    state.keyStoneVertical = val
  },
  [SET_KEYSTONEHORIZONTAL] (state, val) {
    state.keyStoneHorizontal = val
  },
  [SET_ISVANGLEOUT] (state, val) {
    state.isVAngleOut = val
  },
  [SET_OUTOFSPECVAL] (state, val) {
    state.outOfSpecVal = val
  },
  [SET_ISOUTOFSPEC] (state, val) {
    state.isOutOfSpec = val
  },
  [SET_LANGUAGEDEFAULT] (state, val) {
    state.languageDefault = val
  },
  [SET_SEARCHTABACTIVE] (state, val) {
    state.searchTabActive = val
  },
  [SET_ISSIMPLE] (state, val) {
    state.isSimple = val
  },
  [SET_USTLENSTOFRONTPJ] (state, val) {
    state.ustLensToFrontPj = val
  },
  [SET_CURVESHAPE] (state, val) {
    state.curveShape = val
  },
  [SET_CURVEDIRECTION] (state, val) {
    state.curveDirection = val
  },
  [SET_MUPOINTS] (state, val) {
    state.muPoints = val
  },
  [SET_SETTINGACTIVE] (state, val) {
    state.SettingActive = val
  },
  [SET_SCREENSIZEACTIVE] (state, val) {
    state.screenActive = val
  },
  [SET_DISABLEDNONE] (state, val) {
    state.DisableNone = val
  },
  [SET_TABACTIVENAME] (state, val) {
    state.tabActiveName = val
  },
  [SET_INDANGLESWITCH] (state, val) {
    state.indAngleSwitch = val
  },
  [SET_INDANGLEREMAINPINTS] (state, val) {
    state.indAngleRemainPints = val
  },
  [SET_CORNERCORAREAS] (state, val) {
    state.cornerCorAreas = val
  },
  [SET_ISONCORNERAREAS] (state, val) {
    state.isOnCornerAreas = val
  },
  [SET_TOUCHWALLFLAG] (state, val) {
    state.touchWallFlag = val
  },
  [SET_FONTSIZE] (state, val) {
    state.setfontSize = val
  },
  [SET_CURVEDEPTH] (state, val) {
    state.curveDepth = val
  },
  [SET_LENSSHIFTRANGEBOOL] (state, val) {
    state.lensShiftRangeBool = val
  },
  [SET_LENSSHIFTRANGE] (state, val) {
    state.lensShiftRange = val
  },
  [SET_BRIGHTNESSGUIDE] (state, val) {
    state.brightnessGuide = val
  },
  [SET_CURVECENTER] (state, val) {
    state.curveCenter = val
  },
  [SET_CURVERADIUS] (state, val) {
    state.curveRadius = val
  },
  [SET_CURVECENTRALANGLE] (state, val) {
    state.curveCentralAngle = val
  },
  [SET_CURVECHORDLENGTH] (state, val) {
    state.curveChordLength = val
  },
  [SET_CURVESCREENHEIGHT] (state, val) {
    state.curveScreenHeight = val
  },
  [SET_BLENDING_SCREEN_SHAPE] (state, val) {
    state.blendingParam.screenShape = val
  },
  [SET_BLENDING_SCREEN_SHAPESHOW] (state, val) {
    state.blendingParam.shapeShow = val
  },
  [SET_BLENDING_SCREEN_WIDHT] (state, val) {
    state.blendingParam.screenSize.width = val
  },
  [SET_BLENDING_SCREEN_HEIGHT] (state, val) {
    state.blendingParam.screenSize.height = val
  },
  [SET_BLENDING_RATIO] (state, val) {
    state.blendingParam.ratio = val
  },
  [SET_BLENDING_RADIUS] (state, val) {
    state.blendingParam.radius = val
  },
  [SET_BLENDING_SCREENHEIGHT] (state, val) {
    state.blendingParam.screenHeight = val
  },
  [SET_BLENDING_LENSHEIGHT] (state, val) {
    state.blendingParam.lensHeight = val
  },
  [SET_BLENDING_LENSHEIGHTRATE_MIN] (state, val) {
    state.blendingParam.lensHeightRate.min = val
  },
  [SET_BLENDING_LENSHEIGHTRATE_MAX] (state, val) {
    state.blendingParam.lensHeightRate.max = val
  },
  [SET_BLENDING_CURVESELECT] (state, val) {
    state.blendingParam.curveSelect = val
  },
  [SET_BLENDING_ANGLE] (state, val) {
    state.blendingParam.angle = val
  },
  [SET_BLENDING_DEPTH] (state, val) {
    state.blendingParam.depth = val
  },
  [SET_BLENDING_ARC] (state, val) {
    state.blendingParam.arc = val
  },
  [SET_BLENDING_AVAPOINT] (state, val) {
    state.blendingAvaPoint = val
  },
  [SET_BLENDING_ISPROJECTPOSITION] (state, val) {
    state.isProjectPosition = val
  },
  [SET_BLENDING_SIMULATETABDATA] (state, val) {
    state.simulateTabData = val
  },
  [SET_BLENDING_SIMULATETABSELE] (state, val) {
    state.simulateTabSele = val
  },
  [SET_BLENDINGUNIT] (state, val) {
    state.blendingUnit = val
  },
  [SET_BLENDING_POSITION] (state, val) {
    state.blendingParam.position = val
  },
  [SET_BLENDING_SELENSDATA] (state, val) {
    state.blendingParam.seLensData = val
  },
  [SET_BLENDING_VLENSSHIFT] (state, val) {
    state.blendingParam.vLensShift = val
  },
  [SET_BLENDING_HLENSSHIFT] (state, val) {
    state.blendingParam.hLensShift = val
  },
  [SET_BLENDING_VHLENSSHIFT] (state, val) {
    state.blendingParam.vhLensShift = val
  },
  [SET_BLENDING_VLENSSHIFTNOW] (state, val) {
    state.blendingParam.vLensShiftNow = val
  },
  [SET_BLENDING_RANGE_MIN] (state, val) {
    state.blendingParam.range.min = val
  },
  [SET_BLENDING_RANGE_MAX] (state, val) {
    state.blendingParam.range.max = val
  },
  [SET_BLENDING_NUMBER_H] (state, val) {
    state.blendingParam.number.h = val
  },
  [SET_BLENDING_NUMBER_V] (state, val) {
    state.blendingParam.number.v = val
  },
  [SET_BLENDING_LENSSHIFTV] (state, val) {
    state.blendingParam.lensShiftV = val
  },
  [SET_BLENDING_POSITIONLIMITW] (state, val) {
    state.blendingPositionLimit.w = val
  },
  [SET_BLENDING_POSITIONLIMITH] (state, val) {
    state.blendingPositionLimit.h = val
  },
  [SET_SIMULATESWITCHFLAG] (state, val) {
    state.simulateSwitchFlag = val
  },
  [SET_BLENDINGEDGEPOINTS] (state, val) {
    state.blendingEdgePoints = val
  },
  [SET_THROWACTIVE] (state, val) {
    state.throwDisActive = val
  },
  [SET_THROWDISSLIDERTFORMAT] (state, val) {
    state.throwDisSlidertFormat = val
  },
  [SET_THROWDISSLIDERWFORMAT] (state, val) {
    state.throwDisSliderwFormat = val
  },
  [SET_RATIOSCREENSIZEMIN] (state, val) {
    state.ratioScreenSizeMin = val
  },
  [SET_RATIOSCREENSIZEMAX] (state, val) {
    state.ratioScreenSizeMax = val
  },
  [SET_THROWERROR] (state, val) {
    state.throwError = val
  },
  [SET_MDDEDATA] (state, val) {
    state.modeData = val
  },
  [SET_FROMBLENDING] (state, val) {
    state.fromBlending = val
  },
  [SET_BLENDING] (state, val) {
    state.blendingParam = val
  },
  [SET_THROWDISTANCE2SCREENSIZWIDTH] (state, val) {
    state.throwDistance2screenSizWidth = val
  },
  [SET_LANGUAGEFLAG] (state, val) {
    state.languageFlag = val
  },
  [SET_MIXRATEHVAL] (state, val) {
    state.mixRateHVal = val
  },
  [SET_MIXRATEVVAL] (state, val) {
    state.mixRateVVal = val
  },
  [SET_FLOORFOOTPROJECTORCHECKED] (state, val) {
    state.floorFootProjectorChecked = val
  },
  [SET_CONTRASTDATA] (state, val) {
    state.contrastData = val
  },
  [SET_DISTANCE2WALL] (state, val) {
    state.distance2Wall = val
  },
  [SET_CURVEDCORRECTIONSCREEN_W] (state, val) {
    state.curvedCorrectionScreen.w = val
  },
  [SET_CURVEDCORRECTIONSCREEN_H] (state, val) {
    state.curvedCorrectionScreen.h = val
  },
  [SET_CURVEDCORRECTIONSCREEN_SIZE] (state, val) {
    state.curvedCorrectionScreen.size = val
  },
  [SET_ALL] (state, val) {
    try {
      Object.keys(state).forEach(key => {
        state[key] = val[key] ? val[key] : state[key]
      })
    } catch (e) {
      alert(this.$t('T_ALERT_DISPLAY_INPUT_ERROR'))
    }
  },
  [SET_SAVE_DATE] (state, val) {
    state.saveDate = val
  },
  [SET_RESET_STATE] (state, val) {
    Object.assign(state, val)
  },
  [SET_HISTORY_RADIO] (state, val) {
    state.radioSelected = val
  },
  [SET_HISTORY_KEY] (state, val) {
    state.selectedKey = val
  },
  [SET_THROWDISSLIDERMIN] (state, val) {
    state.throwDisSliderMin = val
  },
  [SET_THROWDISSLIDERMAX] (state, val) {
    state.throwDisSliderMax = val
  },
  [SET_THROWDISSLIDERW] (state, val) {
    state.throwDisSliderw = val
  },
  [SET_THROWDISSLIDERT] (state, val) {
    state.throwDisSlidert = val
  },
  [SET_OVERLAPH] (state, val) {
    state.overlapH = val
  },
  [SET_OVERLAPV] (state, val) {
    state.overlapV = val
  },
  [SET_ISHISTORYROWCLICK] (state, val) {
    state.isHistoryRowClick = val
  },
  [SET_CORRECTIONNGINFOMSG] (state, val) {
    state.correctionNGInfoMSG = val
  },
  [SET_LIMITVALUE] (state, val) {
    state.limitValue = val
  },
  [SET_LENSLIST] (state, val) {
    state.lensList = val
  },
  [SET_WIDESTATUS] (state, val) {
    state.wideStatus = val
  },
  [SET_TELESTATUS] (state, val) {
    state.teleStatus = val
  },
  [SET_RECOMMENDLENS] (state, val) {
    state.recommendLens = val
  },
  [SET_BLENDINGEDGEPOINTS_INIT] (state, val) {
    state.blendingEdgePointsInit = val
  },
  [SET_CAMERA_ASSIST_SIZE_MIN] (state, val) {
    state.cameraAssistSizeMin = val
  },
  [SET_CAMERA_ASSIST_SIZE_MAX] (state, val) {
    state.cameraAssistSizeMax = val
  },
  [SET_DATA_TIPS] (state, val) {
    state.dataTips = val
  },
  [SET_PROJECTION_COVER_SCREEN] (state, val) {
    state.projectionCoverScreen = val
  },
  [SET_CEILINGBOTTOMPROJECTORCHECKED] (state, val) {
    state.ceilingBottomProjectorChecked = val
  },
  [SET_WALLWALLPROJECTORCHECKED] (state, val) {
    state.wallWallProjectorChecked = val
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js